import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../../appConstants";
import { getToken } from "../../authentication";

export const getApplicableCoupons = async (userId, locationId, dspId,requestId) => {
    try {
        const token = getToken();
        const url = buildUrl(SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/customerSuccessEngineer/coupon", {
            userId: userId ? userId : undefined,
            locationId: locationId ? locationId : undefined,
            dspId: dspId ? dspId : undefined,
            requestId:requestId?requestId:undefined,
        })
        const response = await fetch(url,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response.status === 204) {
            return [];
        }
        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while getting onboarded users ");
        }
        return res.coupons;
    } catch (err) {
        throw (err)
    }
}


